<template>
  <div v-if="$store.getters.token">
    <div class="tab-plan verify-tab">
      <div class="kyc-tips">
        <i class="icon-alert"><img :src="$getThemeImagePath('icon-alert-kyc.png')" alt=""></i>
        <p class="kyc-tipContent">
          {{ $t("Bao.kyc_verifydetail") }}
          <br>
          <template v-if="memberInfo.is_pass_KYC !== 0">
            {{ $t("Bao.kyc_already") }}
          </template>
          <span class="t-highlight">
            <!-- 驗證審核中 -->
            <template v-if="memberInfo.is_pass_KYC === 2">
              {{ $t("Bao.kyc_audit") }}
            </template>
            <!-- 已驗證 -->
            <template v-else-if="memberInfo.is_pass_KYC === 1">
              {{ $t("Bao.kyc_pass_verify") }}
            </template>
            <!-- 未經過驗證 -->
            <template v-else-if="memberInfo.is_pass_KYC === 0">
              {{ $t("Bao.kyc_upload_docs") }}
            </template>

          </span>
        </p>
      </div>

      <div class="accordion">
        <!-- 身分證明 -->
        <div class="accordion-item">
          <div class="accordion-header" :class="{ active: activeItems['item1'] }" @click="toggleItem('item1')">
            <div class="fs-14px">
              {{ $t("Bao.kyc_idcard") }} <span class="fs-11px text-danger">*</span>
            </div>
            <i v-show="!hideIdentity" class="fas fa-chevron-right paginationArr" />
          </div>

          <div v-show="activeItems['item1']" class="accordion-container">
            <div class="accordion-content">
              <div class="kyc-contentBox">
                <p>
                  {{ $t("Bao.kyc_upload_below") }}
                  <span class="highlight">{{ $t("Bao.kyc_oneof") }}</span>
                  {{ $t("Bao.kyc_docs") }}
                </p>
                <div class="kyc-ex-pic-frame">
                  <img :src="$getThemeImagePath('my_kyc_ex1.png')" alt="">
                </div>
                <div class="row-frame gx-3 gy-3">
                  <div class="colu colu-6 colu-xl-4">
                    <button
                      class="btn btn-upload uploadPic fs-14-w-700 flex-fill"
                      @click="setKYCUrl('Identity', 'driver')"
                    >
                      <span class="btnUploadText text-align-L">{{ $t("Bao.driver_selfie") }}</span>
                      <i class="fa-solid fa-circle-plus fs-14px" />
                    </button>
                  </div>
                  <div class="colu colu-6 colu-xl-4">
                    <button
                      class="btn btn-upload uploadPic fs-14-w-700 flex-fill"
                      @click="setKYCUrl('Identity', 'numcard')"
                    >
                      <span class="btnUploadText text-align-L">{{ $t("Bao.numcard_selfie") }}</span>
                      <i class="fa-solid fa-circle-plus fs-14px" />
                    </button>
                  </div>
                  <div class="colu colu-6 colu-xl-4">
                    <button
                      class="btn btn-upload uploadPic fs-14-w-700 flex-fill"
                      @click="setKYCUrl('Identity', 'passport')"
                    >
                      <span class="btnUploadText text-align-L">{{ $t("Bao.passport_selfie") }}</span>
                      <i class="fa-solid fa-circle-plus fs-14px" />
                    </button>
                  </div>
                  <div class="colu colu-6 colu-xl-4">
                    <button
                      class="btn btn-upload uploadPic fs-14-w-700 flex-fill"
                      @click="setKYCUrl('Identity', 'debtcard')"
                    >
                      <span class="btnUploadText text-align-L">{{ $t("Bao.debtcard_selfie") }}</span>
                      <i class="fa-solid fa-circle-plus fs-14px" />
                    </button>
                  </div>
                  <div class="colu colu-6 colu-xl-4">
                    <button
                      class="btn btn-upload uploadPic fs-14-w-700 flex-fill"
                      @click="setKYCUrl('Identity', 'esidentcard')"
                    >
                      <span class="btnUploadText text-align-L">{{ $t("Bao.esidentcard_selfie") }}</span>
                      <i class="fa-solid fa-circle-plus fs-14px" />
                    </button>
                  </div>
                  <div class="colu colu-6 colu-xl-4">
                    <button
                      class="btn btn-upload uploadPic fs-14-w-700 flex-fill"
                      @click="setKYCUrl('Identity', 'eternal')"
                    >
                      <span class="btnUploadText text-align-L">{{ $t("Bao.eternal_selfie") }}</span>
                      <i class="fa-solid fa-circle-plus fs-14px" />
                    </button>
                  </div>
                </div>
                <!--eslint-disable-next-line-->
                <p v-html="kycIdCard" />
              </div>
            </div>
          </div>
        </div>

        <!-- 地址證明 -->
        <div class="accordion-item">
          <div class="accordion-header" :class="{ active: activeItems['item2'] }" @click="toggleItem('item2')">
            <div class="fs-14px">
              {{ $t("Bao.kyc_address") }} <span class="fs-11px text-danger">*</span>
            </div>
            <i v-show="!hideAddress" class="fas fa-chevron-right paginationArr" />
          </div>
          <div v-show="activeItems['item2']" class="accordion-container">
            <div class="accordion-content">
              <div class="kyc-contentBox">
                <p>
                  {{ $t("Bao.kyc_upload_below") }}
                  <span class="t-highlight">{{ $t("Bao.kyc_oneof") }}</span>
                  {{ $t("Bao.kyc_docs") }}
                </p>
                <div class="kyc-ex-pic-frame">
                  <img :src="$getThemeImagePath('my_kyc_ex2.webp')" alt="">
                </div>
                <div class="row-frame gx-3 gy-3">
                  <div class="colu colu-6 colu-xl-4">
                    <button
                      class="btn btn-upload uploadPic fs-14-w-700 flex-fill"
                      @click="setKYCUrl('Address', 'residence')"
                    >
                      <span class="btnUploadText text-align-L">{{ $t("Bao.residence_permit") }}</span>
                      <i class="fa-solid fa-circle-plus fs-14px" />
                    </button>
                  </div>
                  <div class="colu colu-6 colu-xl-4">
                    <button
                      class="btn btn-upload uploadPic fs-14-w-700 flex-fill"
                      @click="setKYCUrl('Address', 'utility')"
                    >
                      <span class="btnUploadText text-align-L">{{ $t("Bao.utility_bill") }}</span>
                      <i class="fa-solid fa-circle-plus fs-14px" />
                    </button>
                  </div>

                  <div class="colu colu-6 colu-xl-4">
                    <button
                      class="btn btn-upload uploadPic fs-14-w-700 flex-fill"
                      @click="setKYCUrl('Address', 'credit')"
                    >
                      <span class="btnUploadText text-align-L">{{ $t("Bao.credit_bill") }}</span>
                      <i class="fa-solid fa-circle-plus fs-14px" />
                    </button>
                  </div>
                </div>
                <!--eslint-disable-next-line-->
                <p v-html="kycAddressVerification" />
              </div>
            </div>
          </div>
        </div>

        <!-- 其他文件 -->
        <div class="accordion-item">
          <div class="accordion-header" :class="{ active: activeItems['item3'] }" @click="toggleItem('item3')">
            <div class="fs-14px">
              {{ $t("Bao.send_additional") }}
            </div>
            <i v-show="!hideOthers" class="fas fa-chevron-right paginationArr" />
          </div>
          <div v-show="activeItems['item3']" class="accordion-container">
            <div class="accordion-content">
              <div class="kyc-contentBox">
                <p> {{ $t("Bao.kyc_additional") }}</p>
                <div class="row-frame gx-3 gy-3">
                  <div class="colu-12">
                    <button
                      class="btn btn-upload uploadPic fs-14-w-700 flex-fill"
                      @click="setKYCUrl('Others', 'other')"
                    >
                      <span class="btnUploadText text-align-L">{{ $t("Bao.select_file_photo") }}</span>
                      <i class="fa-solid fa-circle-plus fs-14px" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal Popup -->
      <div v-show="isModalOpen" class="kyc-popup-wrap popup-wrap" :class="{ active: isModalOpen }">
        <div class="popup-box">
          <a v-if="isIframeLoaded" class="popup-close" @click="closeIframe"><i class="fa-solid fa-xmark" /></a>
          <div class="content">
            <iframe
              v-if="KYCUrl"
              :src="KYCUrl"
              class="kyc-popup-package"
              @load="iframeLoaded"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { KycReview } from '@/api/user'
import { getFullDomain } from '@/utils/tool'
import { page } from '@/api/common'

export default {
  data() {
    return {
      activeItems: {},
      KYCUrl: null,
      KYCVer: process.env.VUE_APP_KYC_VER,
      isModalOpen: false,
      isIframeLoaded: false,
      kycIdCard: '',
      kycAddressVerification: '',
      currentType: null
    }
  },
  computed: {
    memberInfo() {
      return this.$store.state.user.memberInfo
    },
    hideIdentity() {
      return this.shouldHide('Identity')
    },
    hideAddress() {
      return this.shouldHide('Address')
    },
    hideOthers() {
      return this.shouldHide('Others')
    }
  },
  watch: {
    'memberInfo.is_pass_KYC': function(newValue, oldValue) {
      if (newValue === 0) {
        localStorage.removeItem('kycTypes')
      }
    }
  },
  created() {
    page({ type: 'kyc_id_card' }).then(response => {
      this.kycIdCard = response.data.data.content
    }).catch(error => {
      console.error('Failed to fetch kycIdCard:', error)
    })

    page({ type: 'kyc_address_verification' }).then(response => {
      this.kycAddressVerification = response.data.data.content
    }).catch(error => {
      console.error('Failed to fetch kycAddressVerification:', error)
    })
  },
  mounted() {
    window.addEventListener('message', this.receiveMessage, false)
  },
  beforeDestroy() {
    window.removeEventListener('message', this.receiveMessage)
  },
  methods: {
    setKYCUrl(type, subType) {
      this.currentType = type
      this.isIframeLoaded = false
      const domain = getFullDomain()
      this.KYCUrl = null

      setTimeout(() => {
        this.KYCUrl = `https://script.google.com/macros/s/${this.KYCVer}/exec?brand=${this.memberInfo.brand_id}&promotion=${this.memberInfo.promotion_code}&type=${type}&subtype=${subType}&lang=${this.$store.state.user.language}&domain=${domain}`
      }, 30)

      this.isModalOpen = true
    },

    receiveMessage(event) {
      // 寬鬆的來源驗證,接受所有 Google 相關域名
      const isGoogleOrigin = event.origin.includes('google.com') ||
                         event.origin.includes('googleusercontent.com')

      if (!isGoogleOrigin) {
        console.warn('Rejected message from:', event.origin)
        return
      }

      if (event.data === 'uploadSuccess') {
        // Store the current type in localStorage
        const existingTypes = JSON.parse(localStorage.getItem('kycTypes') || '[]')
        if (!existingTypes.some(item => item.type === this.currentType)) {
          existingTypes.push({ type: this.currentType })
          localStorage.setItem('kycTypes', JSON.stringify(existingTypes))
        }

        KycReview(this.memberInfo.id).then(response => {
          // SET memberInfo.is_pass_KYC from 0 to 2, 未通過 => 審核中
          console.log(response)
        }).catch(error => {
          console.error('Error, KycReview:', error)
        })
      }
    },
    shouldHide(type) {
      const existingTypes = JSON.parse(localStorage.getItem('kycTypes') || '[]')
      const typeExists = existingTypes.some(item => item.type === type)
      return this.memberInfo.is_pass_KYC === 2 && typeExists || this.memberInfo.is_pass_KYC === 1
    },
    iframeLoaded() {
      this.isIframeLoaded = true
    },
    toggleItem(index) {
      if (index === 'item1' && this.hideIdentity) return
      if (index === 'item2' && this.hideAddress) return
      if (index === 'item3' && this.hideOthers) return
      this.$set(this.activeItems, index, !this.activeItems[index])
    },
    closeIframe() {
      this.isModalOpen = false
      this.KYCUrl = null
      this.isIframeLoaded = false
      window.location.reload()
    }
  }
}
</script>
